<template>
  <v-layout>
    <v-col v-if="Account.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="Account.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.account") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Account.obj.name"
                >
                  <template #label>
                    {{ $t(`table.name`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required, Rules.phone]"
                  v-model="Account.obj.phone"
                >
                  <template #label>
                    {{ $t(`table.phone`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required, Rules.email]"
                  v-model="Account.obj.email"
                >
                  <template #label>
                    {{ $t(`table.email`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-datePicker
                  v-model="Account.obj.birthday"
                  :rules="[Rules.date]"
                  birthday
                />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-gender
                  v-model="Account.obj.gender"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-roleAccount
                  v-model="Account.obj.role"
                  :rules="[Rules.array]"
                />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-statusAccount
                  v-model="Account.obj.status"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Account.isValid"
              @click="Account.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ Account.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="Account.isDelete"
      v-model="Account.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ Account.obj.name }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Account",
  }),
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnCreate() {
      const { code } = await this.fnPost({
        url: `/v1/admin/account`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      const { code } = await this.fnPut({
        url: `/v1/admin/account/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnDelete() {
      const { code } = await this.fnDelete({
        url: `/v1/admin/account/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
